import { type PropType } from 'vue';
import { chipProps, type ChipProps } from '../chip/chip';
import type { TooltipPlacement } from '../tooltip/tooltip';

export interface ChipsExcessProps extends ChipProps {
    chips: string[];
    max: number;
    closable?: boolean;
    maxWidth?: string;
    placement?: TooltipPlacement;
}

export const chipsExcessProps = {
    chips: {
        type: Array as PropType<ChipsExcessProps['chips']>,
        default: () => [],
        required: true,
    },
    max: {
        type: Number as PropType<ChipsExcessProps['max']>,
        required: true,
    },
    closable: {
        type: Boolean as PropType<ChipsExcessProps['closable']>,
        default: undefined,
        required: false,
    },
    maxWidth: {
        type: String as PropType<ChipsExcessProps['maxWidth']>,
        default: undefined,
        required: false,
    },
    placement: {
        type: String as PropType<ChipsExcessProps['placement']>,
        default: 'auto',
        required: false,
    },
    ...chipProps,
};

export const chipsExcessEmits = {
    close: (index: number) => typeof index === 'number',
};
